import { ThunkedAction } from '../../interfaces/redux.interface';
import httpService from '../../services/http.service';
import * as operatorsActions from '../constants/operatorsActions';

const getOperatorsSuccess = (payload: any[]) => ({
	type: operatorsActions.GET_OPERATORS_SUCCESS,
	payload,
});

export const fetchOperatorsList =
	(unitIds: number[]): ThunkedAction =>
	dispatch => {
		httpService
			.api<any[]>({
				type: 'getCustomerOperatorsList',
				query: {
					unitIds: unitIds?.map(unit => `${unit}`).join(','),
				},
			})
			.then(data => {
				dispatch(getOperatorsSuccess(data));
			})
			.catch(() => {});
	};
